import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material'
import { useState } from 'preact/hooks'
import { useLocation } from 'preact-iso'
import { api } from '../api/client'
import type { EventCopy } from '../api/generated/EventCopy'
import type { EventDetails } from '../api/generated/EventDetails'
import { useAction } from '../api/useAction'
import { SlugField, useSlug } from './SlugField'

export function DuplicateDialog({ event, onClose }: { event: EventDetails; onClose: () => void }) {
  const { route } = useLocation()
  const [name, setName] = useState('')
  const [slug, setSlug] = useSlug(name)
  const [startsOn, setStartsOn] = useState('')
  const { error, pending, run } = useAction({
    forbidden:
      "La création d'événements est réservée aux personnes autorisées par un administrateur.",
  })
  const submit = (e: Event) => {
    e.preventDefault()
    run(async () => {
      const body: EventCopy = { slug, name, starts_on: startsOn }
      const copy = await api.post<EventDetails>(`/events/${event.slug}/copy`, body)
      onClose()
      route(`/events/${copy.slug}`)
    })
  }
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="xs">
      <form onSubmit={submit}>
        <DialogTitle>Dupliquer l'événement</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText>
              Le nouvel événement reprend les paramètres, les postes et leurs fiches, les créneaux
              et les questions de « {event.name} », sans les bénévoles ni les messages. Vous en
              serez le seul organisateur ; les inscriptions y sont fermées.
            </DialogContentText>
            <TextField
              label="Nom du nouvel événement"
              required
              slotProps={{ htmlInput: { maxLength: 200 } }}
              value={name}
              onInput={(e) => setName((e.target as HTMLInputElement).value)}
            />
            <SlugField value={slug} onChange={setSlug} />
            <TextField
              label="Date de début"
              type="date"
              required
              helperText="Le premier jour de l'événement (sa première date, ou son premier créneau s'il commence avant) passe à cette date ; le reste suit, aux mêmes heures."
              slotProps={{ inputLabel: { shrink: true } }}
              value={startsOn}
              onInput={(e) => setStartsOn((e.target as HTMLInputElement).value)}
            />
            {error && <Alert severity="error">{error}</Alert>}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Annuler</Button>
          <Button type="submit" variant="contained" loading={pending}>
            Dupliquer
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}
